import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import { css } from "aphrodite-jss";
import { styles } from "src/components/dialogs/PublicationSourceDialogStyle";
import { HorizontalBarChart} from "src/components/charts/HorizontalBarChart";
import { ChartItem } from "src/models/ChartItem";
import { appStore } from "src/mobx/AppStore";
import { RequestState } from "src/models/RequestState";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';
import { sortItem, PublicationData } from "src/mobx/FacultyPageStore";

interface IPublicationAuthorDialogProps {
    isOpen: boolean;
    onClose: any;
}

class PublicationAuthorDialogState {
    public readonly selected_co_investigators_tab: number = 0;
}

export class PublicationAuthorDialog extends React.Component<IPublicationAuthorDialogProps,PublicationAuthorDialogState> {
    
    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
    };

    constructor(props: IPublicationAuthorDialogProps){
        super(props);
        this.state = new PublicationAuthorDialogState()
    }

    public render() {
        let content;
        if(!this.props.isOpen){
            content = (
                <div>
                    
                </div>
            );
        }else{

            const selectedYear = appStore.facultyPageStore.authorPageData.selectedYear;
            
            let coAuthorLabel;
            let coAuthorToolTip;
            let coAuthorState;
            if(selectedYear === 0){
                coAuthorLabel = "Co-Authors";
                coAuthorToolTip = "For top 10 cited since 2008 (as reported on scopus.com)";
                coAuthorState = RequestState.SUCCESS;
            }else{
                coAuthorLabel = `Co-Authors for Year: ${selectedYear}`
                coAuthorToolTip = `For: ${selectedYear} (as reported on scopus.com)`;
                coAuthorState = appStore.facultyPageStore.authorPageData.requestState;
            }

            let publicationData; 
            if(selectedYear === 0) {
                publicationData = appStore.facultyPageStore.authorPageData.publicationData;
            }else if(appStore.facultyPageStore.authorPageData.requestState === RequestState.SUCCESS) {
                publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
            }else{
                publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
            }
                
            content = (
                <HorizontalBarChart id="co_investigators"
                    data={this.getCoAuthors(publicationData)}
                    title={coAuthorLabel}
                    tooltip={coAuthorToolTip}
                    customViews={this.buildCoInvestigatorsTabs()}
                    labelName={"Author"}
                    valueLabel={"Num of Pubs"}
                    state ={coAuthorState}
                    tickCutOff={40}
                    yAxisWidth={200}
                />
            )

        }
        

        return (
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        {content}
                    </React.Fragment>
                </div>
            </Dialog>
        );
    }

    private getCoAuthors = (publicationData: PublicationData) => {
        let items;
        if (this.state.selected_co_investigators_tab === 0) {
            items = publicationData.coauthors.slice(0, 10).sort(sortItem);
        } else if (this.state.selected_co_investigators_tab === 1) {
            items = publicationData.coauthors.filter(this.isTrue).slice(0, 10).sort(sortItem);
        } else {
            items = publicationData.coauthors.filter(this.isFalse).slice(0, 10).sort(sortItem);
        }
        return items;
    }

    private isTrue = (chartItem: ChartItem) => {
        const value: string = chartItem.payload;
        return value.toString().toLowerCase() === "true";
    }

    private isFalse = (chartItem: ChartItem) => {
        const value: string = chartItem.payload;
        return value.toString().toLowerCase() === "false";
    }

    private buildCoInvestigatorsTabs = () => {
        return (
            <UncontrolledDropdown size="sm" >
                <DropdownToggle caret={true}>
                    {this.getCoInvestigatorDropDownLabel()}
                </DropdownToggle>
                <DropdownMenu >
                    <DropdownItem onClick={(event: any) => this.onCoAuthorTabSelected(0)}>ALL</DropdownItem>
                    <DropdownItem onClick={(event: any) => this.onCoAuthorTabSelected(1)}>UDEL</DropdownItem>
                    <DropdownItem onClick={(event: any) => this.onCoAuthorTabSelected(2)}>NON-UDEL</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    }

    private onCoAuthorTabSelected = (value: number) => {
        this.setState({ ...this.state, selected_co_investigators_tab: value })
    }

    private getCoInvestigatorDropDownLabel = () => {
        if (this.state.selected_co_investigators_tab === 0) {
            return "ALL";
        } else if (this.state.selected_co_investigators_tab === 1) {
            return "UDEL";
        } else {
            return "NON-UDEL";
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/components/dialogs/PublicationAuthorDialog.tsx